import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { Tabs } from "@ubnt/ui-components/Tabs";
import styled, { css } from "styled-components";

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
}
`;

export const ActiveVideoWrapper = styled.div`
  aspect-ratio: 1536/1600;
  position: relative;
  overflow: visible;
  width: 100%;
  height: 100%;
`;

export const ActiveVideo = styled.video<{ $isActive?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  background: #f7f7f7;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.2s ease-out;

  ${({ $isActive }) =>
    $isActive &&
    css`
      z-index: 1;
      opacity: 1;
      left: 0;
    `}
`;

export const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.1) 81%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 101;

  @media (${BREAKPOINTS.TABLET_AND_DOWN}) {
    max-height: 600px;
  }
`;

export const BackgroundVideo = styled.video<{ $isVisible: boolean }>`
  height: 100%;
  width: 100%;
  aspect-ratio: 1536/1600;
  position: relative;
  background: #f7f7f7;
  z-index: 5;
  opacity: 1;

  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      transition: opacity 0.2s ease-out;
      transition-delay: 0.2s;
      opacity: 0;
    `}
`;

export const Title = styled.h1`
  color: #212427;
  font-size: 30px;
  font-weight: 700;
  line-height: normal;
  position: relative;
  margin: 0;
  z-index: 8;
  text-align: center;
  text-wrap: pretty;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 24px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 20px;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: #808893;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
`;

export const Content = styled.div`
  position: absolute;
  top: 10%;
  width: 100%;
  left: 0;
  z-index: 102;
`;

export const TooltipTriggerWrapper = styled.div`
  position: absolute;
  bottom: 4.75%;
  width: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  gap: 8%;
  margin: 0 1%;
  height: 9.5%;
  transform: translate(-50%, -50%);
`;

export const TooltipTriggerBtn = styled.button<{
  $left: string;
  $isVisible: boolean;
}>`
  left: ${({ $left }) => `${$left}`};
  bottom: 0;
  position: absolute;
  width: 10.35%;
  height: 9.88%;
  background: transparent;
  border: none;
  visibility: hidden;
  display: block;
  border-radius: 18%;
  transform: translate(-50%, -50%);
  pointer-actions: none;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      visibility: visible;
      z-index: 99;
      pointer-actions: auto;
    `}
`;

export const Tooltip = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  width: 100%;
  padding: 0 12px;
  z-index: 100;
  justify-content: center;
  bottom: 0;
  left: 0;
  transform: translateY(90%);
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      display: flex;
      opacity: 1;
    `}
`;

export const TooltipContentWrap = styled.div`
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  padding: 8px 24px 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(12px);
  maxwidth: 50%;
  gap: 4px;
`;

export const TooltipTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #212427;
  font-weight: 700;
`;

export const TooltipDescription = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #808893;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const StyledTabs = styled(Tabs)`
  margin-top: 8px;

  .tabs {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #eeeff1;
  }

  .tab {
    > span {
      display: flex;
      align-items: center;
      color: #676f79;

      svg {
        bottom: 0;
        color: #808893;
        transition: color 0.15s linear;
        margin-right: 4px;
      }
    }

    &:hover:not(.selected-tab) {
      > span {
        color: ${({ theme }) => theme.colors.primaryBlue} !important;

        svg {
          color: ${({ theme }) => theme.colors.primaryBlue};
        }
      }
    }
  }

  .selected-tab {
    background: ${({ theme }) => theme.colors.primaryBlue} !important;

    > span {
      color: ${({ theme }) => theme.colors.white} !important;

      svg path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
